(() => {
  angular
    .module('gm.common.directives')
    .directive('gmySupportEmail', gmySupportEmail);

  function gmySupportEmail(
    Environment
  ) {
    'ngInject';

    const SUPPORT_EMAIL = Environment.urls.support.contact;

    return {
      restrict: 'A',
      compile(_element, attrs) {
        attrs.$set('href', SUPPORT_EMAIL);
        attrs.$set('target', '_blank');
      }
    };
  }
})();
